import { makeAutoObservable, runInAction, reaction } from 'mobx'
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
  query,
  orderBy,
  getDocs,
} from 'firebase/firestore'
import FirebaseApp from '../../../shared/api/firebase'

const db = getFirestore(FirebaseApp)

class FeedbackStore {
  feedbackItems = []
  isLoading = false

  constructor(rootStore) {
    makeAutoObservable(this, { rootStore: false }, { autoBind: true })
    this.organizationStore = rootStore.organizationStore
    this.errorStore = rootStore.errorStore

    // Автоматически загружаем отзывы при появлении организации
    reaction(
      () => this.organizationStore.organization?.id,
      (orgId) => {
        if (orgId) {
          this.fetchFeedback(orgId)
        } else {
          runInAction(() => {
            this.feedbackItems = []
          })
        }
      },
      { fireImmediately: true },
    )
  }

  async fetchFeedback(organizationId) {
    if (!organizationId) return
    this.isLoading = true
    try {
      const path = `organizations/${organizationId}/feedback`
      const collectionRef = collection(db, path)
      const q = query(collectionRef, orderBy('createdAt', 'desc'))

      // Используем нативную функцию getDocs, так как наш хелпер getCollection
      // не предназначен для работы со сложными запросами (Query).
      const querySnapshot = await getDocs(q)
      const feedbackFromDb = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      runInAction(() => {
        this.feedbackItems = feedbackFromDb
      })
    } catch (error) {
      console.error('Ошибка при загрузке отзывов:', error)
      this.errorStore.showError('Не удалось загрузить отзывы.')
    } finally {
      runInAction(() => (this.isLoading = false))
    }
  }

  async addFeedback(feedbackData) {
    const orgId = this.organizationStore.organization?.id
    if (!orgId) {
      return this.errorStore.showError(
        'Невозможно оставить отзыв: организация не найдена.',
      )
    }

    this.isLoading = true
    try {
      const collectionRef = collection(db, 'organizations', orgId, 'feedback')
      await addDoc(collectionRef, {
        ...feedbackData,
        createdAt: serverTimestamp(),
      })
      await this.fetchFeedback(orgId) // Обновляем список
      this.errorStore.showSuccess('Спасибо за ваш отзыв!')
      return true
    } catch (error) {
      console.error('Ошибка при добавлении отзыва:', error)
      this.errorStore.showError('Не удалось отправить отзыв.')
      return false
    } finally {
      runInAction(() => (this.isLoading = false))
    }
  }
}

export default FeedbackStore
